<template>
  <div>
    <div class="form">
      <Form
            id="form"
            :form_id="game_id"
            :submission_id="submission_id"
            :uid="uid"
            :server="server"
            :recaptcha_key="recaptchaKey"
            v-on:results="getResult"
            v-on:step-up="checkStep"
            v-on:step-down="checkStep"
            :relay="codes"
          />
          <br />
          <p v-if="step == 2">
            En cliquant sur « Soumettre », vous acceptez que GARDENA (représentée par HUSQVARNA France SAS RCS Nanterre et ses sociétés affiliées) utilisent vos données personnelles pour vous répondre. Si vous indiquez que vous souhaitez recevoir notre newsletter, nous utiliserons également vos données personnelles pour vous envoyer lesdites newsletters. Nous utiliserons toujours vos données personnelles conformément à notre <a href="https://privacyportal.husqvarnagroup.com/fr/privacy-notice/" target="_blank">Déclaration de confidentialité</a>. Pour en savoir plus sur la manière dont nous traitons vos données, les tiers avec qui nous pouvons les partager, les droits dont vous disposez et les coordonnées d'autres interlocuteurs, consultez notre Déclaration de confidentialité. Vous pouvez vous désinscrire de notre newsletter à tout moment en cliquant sur le bouton de désabonnement figurant dans chaque communication de notre part, ou bien en nous contactant, comme précisé dans la Déclaration de confidentialité.
          </p>
      </div>
  </div>
</template>
<script>
var consts = require('../config');
import axios from "axios";

export default {
  name: "Jouez",
  data: function() {
    return {
      step: 0,
      codes: undefined,
      submission_id: this.$route.params.submissionId,
      uid: this.$route.params.secu,
      game_id: this.$route.params.id,
      server : consts.SERVER_URL,
      gameData: undefined,
      json: undefined,
      recaptchaKey: undefined
    };
  },
  methods: {
    getResult(result) {
      this.$router.push("/finish");
    },
    checkStep (step) {
      this.step = step
    }
  },

  computed: {
    list() {
      //return this.json;
    }
  },
  mounted () {

  },
  created: function() {

  }
}
</script>
<style>
button {
  margin-top:20px;
}
</style>